// extracted by mini-css-extract-plugin
module.exports = {"buttons":"style__buttons__nxbnH"};